import React from "react"
import styled from "styled-components"

import { Box } from "components/box"

import { TextProps } from ".."
import { typography, textTransform, FontConfigurations, textDecoration } from "theme"

const Header = styled(Box)`
  ${typography}
  ${textTransform}
  ${textDecoration}
`

export const H1: React.FunctionComponent<TextProps> = ({ children, as = "h1", ...props }) => (
  <Header as={as} {...FontConfigurations.h1} {...props}>
    {children}
  </Header>
)

export const H2: React.FunctionComponent<TextProps> = ({ children, as = "h2", ...props }) => (
  <Header as={as} {...FontConfigurations.h2} {...props}>
    {children}
  </Header>
)

export const H3: React.FunctionComponent<TextProps> = ({ children, as = "h3", ...props }) => (
  <Header as={as} {...FontConfigurations.h3} {...props}>
    {children}
  </Header>
)

export const H4: React.FunctionComponent<TextProps> = ({ children, as = "h4", ...props }) => (
  <Header as={as} {...FontConfigurations.h4} {...props}>
    {children}
  </Header>
)

export const H5: React.FunctionComponent<TextProps> = ({ children, as = "h5", ...props }) => (
  <Header as={as} {...FontConfigurations.h5} {...props}>
    {children}
  </Header>
)
